import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'checkout',
  component: generateAsyncRouteComponent({
    loader: () => import('./components/CheckoutPageContainer'),
  }),
};
